import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowPointRightCircle = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M24 0C10.766 0 0 10.766 0 24C0 37.234 10.766 48 24 48C37.234 48 48 37.234 48 24C48 10.766 37.234 0 24 0ZM20 34.828L17.172 32L25.172 24L17.172 16L20 13.172L30.828 24L20 34.828Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgArrowPointRightCircle);
export default ForwardRef;
